import type { IntlKey } from 'locales';
import { uniq } from 'lodash-es';
import { isHandledBySamePredicate as areSameTypePredicate, type FieldFormatter } from 'models/forms/fields/utils';

import type { FieldMetadataBase } from './FieldMetadataBase';

export type CustomizableTenorFieldData = {
  currentValue: {
    unit: string;
    value?: number;
  };
  isCustomized: boolean;
};

export type CustomizableTenorFieldMetadata = FieldMetadataBase<'CustomizableTenorField', CustomizableTenorFieldData> & {
  availableUnits: string[];
  placeholderKey: string;
  prependLabelKey?: IntlKey;
};

export function isCustomizableTenorField(val: unknown): val is CustomizableTenorFieldMetadata {
  return (val as CustomizableTenorFieldMetadata)?.type === 'CustomizableTenorField';
}

export function mergeCustomizableTenorFields(
  firstField: CustomizableTenorFieldMetadata,
  secondField: CustomizableTenorFieldMetadata,
): CustomizableTenorFieldMetadata {
  return { ...firstField, availableUnits: uniq([...firstField.availableUnits, ...secondField.availableUnits]) };
}

export const customizableTenorFieldsFormatter: FieldFormatter<CustomizableTenorFieldMetadata> = {
  areSameType: areSameTypePredicate(isCustomizableTenorField),
  isHandled: isCustomizableTenorField,
  merge: mergeCustomizableTenorFields,
  withDefault: f => ({ ...f, availableUnits: ['Month'] }),
};
